import React from "react";
import LoginBox from "../components/login/Login";

function Login() {
  return (
    <section>
      <LoginBox />
    </section>
  );
}

export default Login;
